/** CoStar.Api.SuiteSearchAdapter.ViewModels.TransactionTimeFrame */
export var TransactionTimeFrame;
(function (TransactionTimeFrame) {
    TransactionTimeFrame[TransactionTimeFrame["None"] = 0] = "None";
    TransactionTimeFrame[TransactionTimeFrame["OneYear"] = 1] = "OneYear";
    TransactionTimeFrame[TransactionTimeFrame["TwoYears"] = 2] = "TwoYears";
    TransactionTimeFrame[TransactionTimeFrame["ThreeYears"] = 3] = "ThreeYears";
    TransactionTimeFrame[TransactionTimeFrame["FiveYears"] = 4] = "FiveYears";
})(TransactionTimeFrame || (TransactionTimeFrame = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.TransactionType */
export var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["None"] = 0] = "None";
    TransactionType[TransactionType["Sale"] = 1] = "Sale";
    TransactionType[TransactionType["Lease"] = 2] = "Lease";
    TransactionType[TransactionType["LeaseAndSale"] = 3] = "LeaseAndSale";
})(TransactionType || (TransactionType = {}));
import { AreaType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.AreaType */
export { AreaType };
import { BusinessType } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.BusinessType */
export { BusinessType };
/** CoStar.Api.SuiteSearchAdapter.ViewModels.CompanySortType */
export var CompanySortType;
(function (CompanySortType) {
    CompanySortType[CompanySortType["None"] = 0] = "None";
    CompanySortType[CompanySortType["TenantNameAsc"] = 1] = "TenantNameAsc";
    CompanySortType[CompanySortType["TenantNameDesc"] = 2] = "TenantNameDesc";
    CompanySortType[CompanySortType["IndustryTypeAsc"] = 3] = "IndustryTypeAsc";
    CompanySortType[CompanySortType["IndustryTypeDesc"] = 4] = "IndustryTypeDesc";
    CompanySortType[CompanySortType["CoStarProductMarketAsc"] = 5] = "CoStarProductMarketAsc";
    CompanySortType[CompanySortType["CoStarProductMarketDesc"] = 6] = "CoStarProductMarketDesc";
    CompanySortType[CompanySortType["NumberOfLocationsAsc"] = 7] = "NumberOfLocationsAsc";
    CompanySortType[CompanySortType["NumberOfLocationsDesc"] = 8] = "NumberOfLocationsDesc";
    CompanySortType[CompanySortType["TotalSquareFeetOccupiedAsc"] = 9] = "TotalSquareFeetOccupiedAsc";
    CompanySortType[CompanySortType["TotalSquareFeetOccupiedDesc"] = 10] = "TotalSquareFeetOccupiedDesc";
    CompanySortType[CompanySortType["NumberOfEmployeesAsc"] = 11] = "NumberOfEmployeesAsc";
    CompanySortType[CompanySortType["NumberOfEmployeesDesc"] = 12] = "NumberOfEmployeesDesc";
    CompanySortType[CompanySortType["EmployeeGrowthTypeAsc"] = 13] = "EmployeeGrowthTypeAsc";
    CompanySortType[CompanySortType["EmployeeGrowthTypeDesc"] = 14] = "EmployeeGrowthTypeDesc";
    CompanySortType[CompanySortType["YearFoundedAsc"] = 15] = "YearFoundedAsc";
    CompanySortType[CompanySortType["YearFoundedDesc"] = 16] = "YearFoundedDesc";
    CompanySortType[CompanySortType["ParentNameAsc"] = 17] = "ParentNameAsc";
    CompanySortType[CompanySortType["ParentNameDesc"] = 18] = "ParentNameDesc";
    CompanySortType[CompanySortType["AreaTypeAsc"] = 19] = "AreaTypeAsc";
    CompanySortType[CompanySortType["AreaTypeDesc"] = 20] = "AreaTypeDesc";
    CompanySortType[CompanySortType["CityAsc"] = 21] = "CityAsc";
    CompanySortType[CompanySortType["CityDesc"] = 22] = "CityDesc";
    CompanySortType[CompanySortType["StateAsc"] = 23] = "StateAsc";
    CompanySortType[CompanySortType["StateDesc"] = 24] = "StateDesc";
    CompanySortType[CompanySortType["CountryAsc"] = 25] = "CountryAsc";
    CompanySortType[CompanySortType["CountryDesc"] = 26] = "CountryDesc";
    CompanySortType[CompanySortType["RevenueAsc"] = 27] = "RevenueAsc";
    CompanySortType[CompanySortType["RevenueDesc"] = 28] = "RevenueDesc";
    CompanySortType[CompanySortType["CreditRatingAsc"] = 29] = "CreditRatingAsc";
    CompanySortType[CompanySortType["CreditRatingDesc"] = 30] = "CreditRatingDesc";
    CompanySortType[CompanySortType["HighestUseBySqFtAsc"] = 31] = "HighestUseBySqFtAsc";
    CompanySortType[CompanySortType["HighestUseBySqFtDesc"] = 32] = "HighestUseBySqFtDesc";
    CompanySortType[CompanySortType["PostalCodeAsc"] = 33] = "PostalCodeAsc";
    CompanySortType[CompanySortType["PostalCodeDesc"] = 34] = "PostalCodeDesc";
    CompanySortType[CompanySortType["NAICSDescASC"] = 35] = "NAICSDescASC";
    CompanySortType[CompanySortType["NAICSDescDESC"] = 36] = "NAICSDescDESC";
    CompanySortType[CompanySortType["SICDescASC"] = 37] = "SICDescASC";
    CompanySortType[CompanySortType["SICDescDESC"] = 38] = "SICDescDESC";
    CompanySortType[CompanySortType["PortfolioNumberOfLocationsAsc"] = 39] = "PortfolioNumberOfLocationsAsc";
    CompanySortType[CompanySortType["PortfolioNumberOfLocationsDesc"] = 40] = "PortfolioNumberOfLocationsDesc";
    CompanySortType[CompanySortType["PortfolioTotalSquareFeetOccupiedAsc"] = 41] = "PortfolioTotalSquareFeetOccupiedAsc";
    CompanySortType[CompanySortType["PortfolioTotalSquareFeetOccupiedDesc"] = 42] = "PortfolioTotalSquareFeetOccupiedDesc";
})(CompanySortType || (CompanySortType = {}));
import { EmployeeGrowthType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.EmployeeGrowthType */
export { EmployeeGrowthType };
import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.CurrencyType */
export { CurrencyType };
import { IndustryType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.IndustryType */
export { IndustryType };
import { StoreType } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.StoreType */
export { StoreType };
import { PropertyLevel } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.PropertyLevel */
export { PropertyLevel };
import { AdLevel } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.AdLevel */
export { AdLevel };
/** CoStar.Api.SuiteSearchAdapter.ViewModels.FundSortType */
export var FundSortType;
(function (FundSortType) {
    FundSortType[FundSortType["None"] = 0] = "None";
    FundSortType[FundSortType["PropertyCountASC"] = 1] = "PropertyCountASC";
    FundSortType[FundSortType["PropertyCountDESC"] = 2] = "PropertyCountDESC";
    FundSortType[FundSortType["PropertySquareFeetASC"] = 3] = "PropertySquareFeetASC";
    FundSortType[FundSortType["PropertySquareFeetDESC"] = 4] = "PropertySquareFeetDESC";
    FundSortType[FundSortType["FundManagerCountryASC"] = 5] = "FundManagerCountryASC";
    FundSortType[FundSortType["FundManagerCountryDESC"] = 6] = "FundManagerCountryDESC";
    FundSortType[FundSortType["ContinentASC"] = 7] = "ContinentASC";
    FundSortType[FundSortType["ContinentDESC"] = 8] = "ContinentDESC";
    FundSortType[FundSortType["FundStatusASC"] = 9] = "FundStatusASC";
    FundSortType[FundSortType["FundStatusDESC"] = 10] = "FundStatusDESC";
    FundSortType[FundSortType["AssetsUnderManagementASC"] = 11] = "AssetsUnderManagementASC";
    FundSortType[FundSortType["AssetsUnderManagementDESC"] = 12] = "AssetsUnderManagementDESC";
    FundSortType[FundSortType["DryPowderASC"] = 13] = "DryPowderASC";
    FundSortType[FundSortType["DryPowderDESC"] = 14] = "DryPowderDESC";
    FundSortType[FundSortType["VintageYearASC"] = 15] = "VintageYearASC";
    FundSortType[FundSortType["VintageYearDESC"] = 16] = "VintageYearDESC";
    FundSortType[FundSortType["FundStrategyASC"] = 17] = "FundStrategyASC";
    FundSortType[FundSortType["FundStrategyDESC"] = 18] = "FundStrategyDESC";
    FundSortType[FundSortType["FundStructureASC"] = 19] = "FundStructureASC";
    FundSortType[FundSortType["FundStructureDESC"] = 20] = "FundStructureDESC";
    FundSortType[FundSortType["FundRaisingLaunchDateASC"] = 21] = "FundRaisingLaunchDateASC";
    FundSortType[FundSortType["FundRaisingLaunchDateDESC"] = 22] = "FundRaisingLaunchDateDESC";
    FundSortType[FundSortType["FundRaisingFinalCloseDateASC"] = 23] = "FundRaisingFinalCloseDateASC";
    FundSortType[FundSortType["FundRaisingFinalCloseDateDESC"] = 24] = "FundRaisingFinalCloseDateDESC";
    FundSortType[FundSortType["MonthsInMarketASC"] = 25] = "MonthsInMarketASC";
    FundSortType[FundSortType["MonthsInMarketDESC"] = 26] = "MonthsInMarketDESC";
    FundSortType[FundSortType["TargetIRRGrossMaxASC"] = 27] = "TargetIRRGrossMaxASC";
    FundSortType[FundSortType["TargetIRRGrossMaxDESC"] = 28] = "TargetIRRGrossMaxDESC";
    FundSortType[FundSortType["TargetIRRNetMaxASC"] = 29] = "TargetIRRNetMaxASC";
    FundSortType[FundSortType["TargetIRRNetMaxDESC"] = 30] = "TargetIRRNetMaxDESC";
    FundSortType[FundSortType["FundManagerLocationNameASC"] = 31] = "FundManagerLocationNameASC";
    FundSortType[FundSortType["FundManagerLocationNameDESC"] = 32] = "FundManagerLocationNameDESC";
    FundSortType[FundSortType["Acquisitions24MonthValueASC"] = 33] = "Acquisitions24MonthValueASC";
    FundSortType[FundSortType["Acquisitions24MonthValueDESC"] = 34] = "Acquisitions24MonthValueDESC";
    FundSortType[FundSortType["Dispositions24MonthValueASC"] = 35] = "Dispositions24MonthValueASC";
    FundSortType[FundSortType["Dispositions24MonthValueDESC"] = 36] = "Dispositions24MonthValueDESC";
    FundSortType[FundSortType["SaleListingsCountASC"] = 37] = "SaleListingsCountASC";
    FundSortType[FundSortType["SaleListingsCountDESC"] = 38] = "SaleListingsCountDESC";
    FundSortType[FundSortType["PrimaryCountryASC"] = 39] = "PrimaryCountryASC";
    FundSortType[FundSortType["PrimaryCountryDESC"] = 40] = "PrimaryCountryDESC";
    FundSortType[FundSortType["FundNameASC"] = 41] = "FundNameASC";
    FundSortType[FundSortType["FundNameDESC"] = 42] = "FundNameDESC";
    FundSortType[FundSortType["FundSizeASC"] = 43] = "FundSizeASC";
    FundSortType[FundSortType["FundSizeDESC"] = 44] = "FundSizeDESC";
    FundSortType[FundSortType["PrimaryPropertyTypeASC"] = 45] = "PrimaryPropertyTypeASC";
    FundSortType[FundSortType["PrimaryPropertyTypeDESC"] = 46] = "PrimaryPropertyTypeDESC";
    FundSortType[FundSortType["TargetIRRGrossMinASC"] = 47] = "TargetIRRGrossMinASC";
    FundSortType[FundSortType["TargetIRRGrossMinDESC"] = 48] = "TargetIRRGrossMinDESC";
    FundSortType[FundSortType["TargetIRRNetMinASC"] = 49] = "TargetIRRNetMinASC";
    FundSortType[FundSortType["TargetIRRNetMinDESC"] = 50] = "TargetIRRNetMinDESC";
})(FundSortType || (FundSortType = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.ListingLeaseSortType */
export var ListingLeaseSortType;
(function (ListingLeaseSortType) {
    ListingLeaseSortType[ListingLeaseSortType["None"] = 0] = "None";
    ListingLeaseSortType[ListingLeaseSortType["AddressASC"] = 1] = "AddressASC";
    ListingLeaseSortType[ListingLeaseSortType["AddressDESC"] = 2] = "AddressDESC";
    ListingLeaseSortType[ListingLeaseSortType["CityASC"] = 3] = "CityASC";
    ListingLeaseSortType[ListingLeaseSortType["CityDESC"] = 4] = "CityDESC";
    ListingLeaseSortType[ListingLeaseSortType["CoStarRatingASC"] = 5] = "CoStarRatingASC";
    ListingLeaseSortType[ListingLeaseSortType["CoStarRatingDESC"] = 6] = "CoStarRatingDESC";
    ListingLeaseSortType[ListingLeaseSortType["BuildingSizeASC"] = 7] = "BuildingSizeASC";
    ListingLeaseSortType[ListingLeaseSortType["BuildingSizeDESC"] = 8] = "BuildingSizeDESC";
    ListingLeaseSortType[ListingLeaseSortType["LotSqFtTotalASC"] = 9] = "LotSqFtTotalASC";
    ListingLeaseSortType[ListingLeaseSortType["LotSqFtTotalDESC"] = 10] = "LotSqFtTotalDESC";
    ListingLeaseSortType[ListingLeaseSortType["SqFtAvailableASC"] = 19] = "SqFtAvailableASC";
    ListingLeaseSortType[ListingLeaseSortType["SqFtAvailableDESC"] = 20] = "SqFtAvailableDESC";
    ListingLeaseSortType[ListingLeaseSortType["YearBuiltASC"] = 21] = "YearBuiltASC";
    ListingLeaseSortType[ListingLeaseSortType["YearBuiltDESC"] = 22] = "YearBuiltDESC";
    ListingLeaseSortType[ListingLeaseSortType["NumberOfUnitsASC"] = 25] = "NumberOfUnitsASC";
    ListingLeaseSortType[ListingLeaseSortType["NumberOfUnitsDESC"] = 26] = "NumberOfUnitsDESC";
    ListingLeaseSortType[ListingLeaseSortType["ConstructionStatusASC"] = 27] = "ConstructionStatusASC";
    ListingLeaseSortType[ListingLeaseSortType["ConstructionStatusDESC"] = 28] = "ConstructionStatusDESC";
    ListingLeaseSortType[ListingLeaseSortType["MarketASC"] = 35] = "MarketASC";
    ListingLeaseSortType[ListingLeaseSortType["MarketDESC"] = 36] = "MarketDESC";
    ListingLeaseSortType[ListingLeaseSortType["PostCodeASC"] = 37] = "PostCodeASC";
    ListingLeaseSortType[ListingLeaseSortType["PostCodeDESC"] = 38] = "PostCodeDESC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyNameASC"] = 39] = "PropertyNameASC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyNameDESC"] = 40] = "PropertyNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyTypeASC"] = 41] = "PropertyTypeASC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyTypeDESC"] = 42] = "PropertyTypeDESC";
    ListingLeaseSortType[ListingLeaseSortType["SaleDateOnMarketASC"] = 43] = "SaleDateOnMarketASC";
    ListingLeaseSortType[ListingLeaseSortType["SaleDateOnMarketDESC"] = 44] = "SaleDateOnMarketDESC";
    ListingLeaseSortType[ListingLeaseSortType["SubmarketASC"] = 47] = "SubmarketASC";
    ListingLeaseSortType[ListingLeaseSortType["SubmarketDESC"] = 48] = "SubmarketDESC";
    ListingLeaseSortType[ListingLeaseSortType["FloorASC"] = 49] = "FloorASC";
    ListingLeaseSortType[ListingLeaseSortType["FloorDESC"] = 50] = "FloorDESC";
    ListingLeaseSortType[ListingLeaseSortType["SpaceUseASC"] = 51] = "SpaceUseASC";
    ListingLeaseSortType[ListingLeaseSortType["SpaceUseDESC"] = 52] = "SpaceUseDESC";
    ListingLeaseSortType[ListingLeaseSortType["SpaceTypeASC"] = 53] = "SpaceTypeASC";
    ListingLeaseSortType[ListingLeaseSortType["SpaceTypeDESC"] = 54] = "SpaceTypeDESC";
    ListingLeaseSortType[ListingLeaseSortType["FloorContigASC"] = 57] = "FloorContigASC";
    ListingLeaseSortType[ListingLeaseSortType["FloorContigDESC"] = 58] = "FloorContigDESC";
    ListingLeaseSortType[ListingLeaseSortType["BuildingContigASC"] = 59] = "BuildingContigASC";
    ListingLeaseSortType[ListingLeaseSortType["BuildingContigDESC"] = 60] = "BuildingContigDESC";
    ListingLeaseSortType[ListingLeaseSortType["Occupancy_SortASC"] = 63] = "Occupancy_SortASC";
    ListingLeaseSortType[ListingLeaseSortType["Occupancy_SortDESC"] = 64] = "Occupancy_SortDESC";
    ListingLeaseSortType[ListingLeaseSortType["ServiceTypeASC"] = 109] = "ServiceTypeASC";
    ListingLeaseSortType[ListingLeaseSortType["ServiceTypeDESC"] = 110] = "ServiceTypeDESC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseTermASC"] = 113] = "LeaseTermASC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseTermDESC"] = 114] = "LeaseTermDESC";
    ListingLeaseSortType[ListingLeaseSortType["BuildOutConditionASC"] = 117] = "BuildOutConditionASC";
    ListingLeaseSortType[ListingLeaseSortType["BuildOutConditionDESC"] = 118] = "BuildOutConditionDESC";
    ListingLeaseSortType[ListingLeaseSortType["BuildOutStatusASC"] = 119] = "BuildOutStatusASC";
    ListingLeaseSortType[ListingLeaseSortType["BuildOutStatusDESC"] = 120] = "BuildOutStatusDESC";
    ListingLeaseSortType[ListingLeaseSortType["PropertySubtypeASC"] = 141] = "PropertySubtypeASC";
    ListingLeaseSortType[ListingLeaseSortType["PropertySubtypeDESC"] = 142] = "PropertySubtypeDESC";
    ListingLeaseSortType[ListingLeaseSortType["BuildingClassASC"] = 151] = "BuildingClassASC";
    ListingLeaseSortType[ListingLeaseSortType["BuildingClassDESC"] = 152] = "BuildingClassDESC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyGroupNameASC"] = 183] = "PropertyGroupNameASC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyGroupNameDESC"] = 184] = "PropertyGroupNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["YearRenovatedASC"] = 227] = "YearRenovatedASC";
    ListingLeaseSortType[ListingLeaseSortType["YearRenovatedDESC"] = 228] = "YearRenovatedDESC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseTypeASC"] = 277] = "LeaseTypeASC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseTypeDESC"] = 278] = "LeaseTypeDESC";
    ListingLeaseSortType[ListingLeaseSortType["TrueOwnerASC"] = 285] = "TrueOwnerASC";
    ListingLeaseSortType[ListingLeaseSortType["TrueOwnerDESC"] = 286] = "TrueOwnerDESC";
    ListingLeaseSortType[ListingLeaseSortType["SpaceSqftASC"] = 299] = "SpaceSqftASC";
    ListingLeaseSortType[ListingLeaseSortType["SpaceSqftDESC"] = 300] = "SpaceSqftDESC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyManagerNameASC"] = 379] = "PropertyManagerNameASC";
    ListingLeaseSortType[ListingLeaseSortType["PropertyManagerNameDESC"] = 380] = "PropertyManagerNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["AvailabilityTypeASC"] = 601] = "AvailabilityTypeASC";
    ListingLeaseSortType[ListingLeaseSortType["AvailabilityTypeDESC"] = 602] = "AvailabilityTypeDESC";
    ListingLeaseSortType[ListingLeaseSortType["AvailableOnDateASC"] = 603] = "AvailableOnDateASC";
    ListingLeaseSortType[ListingLeaseSortType["AvailableOnDateDESC"] = 604] = "AvailableOnDateDESC";
    ListingLeaseSortType[ListingLeaseSortType["Contact1LocationNameASC"] = 605] = "Contact1LocationNameASC";
    ListingLeaseSortType[ListingLeaseSortType["Contact1LocationNameDESC"] = 606] = "Contact1LocationNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["Contact2LocationNameASC"] = 607] = "Contact2LocationNameASC";
    ListingLeaseSortType[ListingLeaseSortType["Contact2LocationNameDESC"] = 608] = "Contact2LocationNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["Contact3LocationNameASC"] = 609] = "Contact3LocationNameASC";
    ListingLeaseSortType[ListingLeaseSortType["Contact3LocationNameDESC"] = 610] = "Contact3LocationNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["Contact4LocationNameASC"] = 611] = "Contact4LocationNameASC";
    ListingLeaseSortType[ListingLeaseSortType["Contact4LocationNameDESC"] = 612] = "Contact4LocationNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["Contact5LocationNameASC"] = 613] = "Contact5LocationNameASC";
    ListingLeaseSortType[ListingLeaseSortType["Contact5LocationNameDESC"] = 614] = "Contact5LocationNameDESC";
    ListingLeaseSortType[ListingLeaseSortType["IsLeaseSpaceDivisibleASC"] = 633] = "IsLeaseSpaceDivisibleASC";
    ListingLeaseSortType[ListingLeaseSortType["IsLeaseSpaceDivisibleDESC"] = 634] = "IsLeaseSpaceDivisibleDESC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseNumSpacesASC"] = 635] = "LeaseNumSpacesASC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseNumSpacesDESC"] = 636] = "LeaseNumSpacesDESC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseRentYearlyPerSqftASC"] = 637] = "LeaseRentYearlyPerSqftASC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseRentYearlyPerSqftDESC"] = 638] = "LeaseRentYearlyPerSqftDESC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseRentYearlyTotalASC"] = 639] = "LeaseRentYearlyTotalASC";
    ListingLeaseSortType[ListingLeaseSortType["LeaseRentYearlyTotalDESC"] = 640] = "LeaseRentYearlyTotalDESC";
})(ListingLeaseSortType || (ListingLeaseSortType = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.ListingSaleSortType */
export var ListingSaleSortType;
(function (ListingSaleSortType) {
    ListingSaleSortType[ListingSaleSortType["None"] = 0] = "None";
    ListingSaleSortType[ListingSaleSortType["AddressASC"] = 1] = "AddressASC";
    ListingSaleSortType[ListingSaleSortType["AddressDESC"] = 2] = "AddressDESC";
    ListingSaleSortType[ListingSaleSortType["CityASC"] = 3] = "CityASC";
    ListingSaleSortType[ListingSaleSortType["CityDESC"] = 4] = "CityDESC";
    ListingSaleSortType[ListingSaleSortType["CoStarRatingASC"] = 5] = "CoStarRatingASC";
    ListingSaleSortType[ListingSaleSortType["CoStarRatingDESC"] = 6] = "CoStarRatingDESC";
    ListingSaleSortType[ListingSaleSortType["BuildingSizeASC"] = 7] = "BuildingSizeASC";
    ListingSaleSortType[ListingSaleSortType["BuildingSizeDESC"] = 8] = "BuildingSizeDESC";
    ListingSaleSortType[ListingSaleSortType["LotSqFtTotalASC"] = 9] = "LotSqFtTotalASC";
    ListingSaleSortType[ListingSaleSortType["LotSqFtTotalDESC"] = 10] = "LotSqFtTotalDESC";
    ListingSaleSortType[ListingSaleSortType["SalePriceASC"] = 15] = "SalePriceASC";
    ListingSaleSortType[ListingSaleSortType["SalePriceDESC"] = 16] = "SalePriceDESC";
    ListingSaleSortType[ListingSaleSortType["PricePerBuildingSqftASC"] = 17] = "PricePerBuildingSqftASC";
    ListingSaleSortType[ListingSaleSortType["PricePerBuildingSqftDESC"] = 18] = "PricePerBuildingSqftDESC";
    ListingSaleSortType[ListingSaleSortType["SqFtAvailableASC"] = 19] = "SqFtAvailableASC";
    ListingSaleSortType[ListingSaleSortType["SqFtAvailableDESC"] = 20] = "SqFtAvailableDESC";
    ListingSaleSortType[ListingSaleSortType["YearBuiltASC"] = 21] = "YearBuiltASC";
    ListingSaleSortType[ListingSaleSortType["YearBuiltDESC"] = 22] = "YearBuiltDESC";
    ListingSaleSortType[ListingSaleSortType["NumberOfUnitsASC"] = 25] = "NumberOfUnitsASC";
    ListingSaleSortType[ListingSaleSortType["NumberOfUnitsDESC"] = 26] = "NumberOfUnitsDESC";
    ListingSaleSortType[ListingSaleSortType["ConstructionStatusASC"] = 27] = "ConstructionStatusASC";
    ListingSaleSortType[ListingSaleSortType["ConstructionStatusDESC"] = 28] = "ConstructionStatusDESC";
    ListingSaleSortType[ListingSaleSortType["MarketASC"] = 35] = "MarketASC";
    ListingSaleSortType[ListingSaleSortType["MarketDESC"] = 36] = "MarketDESC";
    ListingSaleSortType[ListingSaleSortType["PostCodeASC"] = 37] = "PostCodeASC";
    ListingSaleSortType[ListingSaleSortType["PostCodeDESC"] = 38] = "PostCodeDESC";
    ListingSaleSortType[ListingSaleSortType["PropertyNameASC"] = 39] = "PropertyNameASC";
    ListingSaleSortType[ListingSaleSortType["PropertyNameDESC"] = 40] = "PropertyNameDESC";
    ListingSaleSortType[ListingSaleSortType["PropertyTypeASC"] = 41] = "PropertyTypeASC";
    ListingSaleSortType[ListingSaleSortType["PropertyTypeDESC"] = 42] = "PropertyTypeDESC";
    ListingSaleSortType[ListingSaleSortType["SaleDateOnMarketASC"] = 43] = "SaleDateOnMarketASC";
    ListingSaleSortType[ListingSaleSortType["SaleDateOnMarketDESC"] = 44] = "SaleDateOnMarketDESC";
    ListingSaleSortType[ListingSaleSortType["SubmarketASC"] = 47] = "SubmarketASC";
    ListingSaleSortType[ListingSaleSortType["SubmarketDESC"] = 48] = "SubmarketDESC";
    ListingSaleSortType[ListingSaleSortType["PercentLeasedASC"] = 87] = "PercentLeasedASC";
    ListingSaleSortType[ListingSaleSortType["PercentLeasedDESC"] = 88] = "PercentLeasedDESC";
    ListingSaleSortType[ListingSaleSortType["SaleStatusASC"] = 89] = "SaleStatusASC";
    ListingSaleSortType[ListingSaleSortType["SaleStatusDESC"] = 90] = "SaleStatusDESC";
    ListingSaleSortType[ListingSaleSortType["CapRateASC"] = 131] = "CapRateASC";
    ListingSaleSortType[ListingSaleSortType["CapRateDESC"] = 132] = "CapRateDESC";
    ListingSaleSortType[ListingSaleSortType["SaleTypeASC"] = 133] = "SaleTypeASC";
    ListingSaleSortType[ListingSaleSortType["SaleTypeDESC"] = 134] = "SaleTypeDESC";
    ListingSaleSortType[ListingSaleSortType["PropertySubtypeASC"] = 141] = "PropertySubtypeASC";
    ListingSaleSortType[ListingSaleSortType["PropertySubtypeDESC"] = 142] = "PropertySubtypeDESC";
    ListingSaleSortType[ListingSaleSortType["BuildingClassASC"] = 151] = "BuildingClassASC";
    ListingSaleSortType[ListingSaleSortType["BuildingClassDESC"] = 152] = "BuildingClassDESC";
    ListingSaleSortType[ListingSaleSortType["PricePerUnitASC"] = 169] = "PricePerUnitASC";
    ListingSaleSortType[ListingSaleSortType["PricePerUnitDESC"] = 170] = "PricePerUnitDESC";
    ListingSaleSortType[ListingSaleSortType["PricePerLotSqFtASC"] = 225] = "PricePerLotSqFtASC";
    ListingSaleSortType[ListingSaleSortType["PricePerLotSqFtDESC"] = 226] = "PricePerLotSqFtDESC";
    ListingSaleSortType[ListingSaleSortType["YearRenovatedASC"] = 227] = "YearRenovatedASC";
    ListingSaleSortType[ListingSaleSortType["YearRenovatedDESC"] = 228] = "YearRenovatedDESC";
    ListingSaleSortType[ListingSaleSortType["TrueOwnerASC"] = 285] = "TrueOwnerASC";
    ListingSaleSortType[ListingSaleSortType["TrueOwnerDESC"] = 286] = "TrueOwnerDESC";
    ListingSaleSortType[ListingSaleSortType["SaleCategoryASC"] = 287] = "SaleCategoryASC";
    ListingSaleSortType[ListingSaleSortType["SaleCategoryDESC"] = 288] = "SaleCategoryDESC";
    ListingSaleSortType[ListingSaleSortType["PropertyManagerNameASC"] = 379] = "PropertyManagerNameASC";
    ListingSaleSortType[ListingSaleSortType["PropertyManagerNameDESC"] = 380] = "PropertyManagerNameDESC";
    ListingSaleSortType[ListingSaleSortType["InvestmentTypeASC"] = 501] = "InvestmentTypeASC";
    ListingSaleSortType[ListingSaleSortType["InvestmentTypeDESC"] = 502] = "InvestmentTypeDESC";
    ListingSaleSortType[ListingSaleSortType["FundNameASC"] = 521] = "FundNameASC";
    ListingSaleSortType[ListingSaleSortType["FundNameDESC"] = 522] = "FundNameDESC";
    ListingSaleSortType[ListingSaleSortType["Contact1LocationNameASC"] = 605] = "Contact1LocationNameASC";
    ListingSaleSortType[ListingSaleSortType["Contact1LocationNameDESC"] = 606] = "Contact1LocationNameDESC";
    ListingSaleSortType[ListingSaleSortType["Contact2LocationNameASC"] = 607] = "Contact2LocationNameASC";
    ListingSaleSortType[ListingSaleSortType["Contact2LocationNameDESC"] = 608] = "Contact2LocationNameDESC";
    ListingSaleSortType[ListingSaleSortType["Contact3LocationNameASC"] = 609] = "Contact3LocationNameASC";
    ListingSaleSortType[ListingSaleSortType["Contact3LocationNameDESC"] = 610] = "Contact3LocationNameDESC";
    ListingSaleSortType[ListingSaleSortType["Contact4LocationNameASC"] = 611] = "Contact4LocationNameASC";
    ListingSaleSortType[ListingSaleSortType["Contact4LocationNameDESC"] = 612] = "Contact4LocationNameDESC";
    ListingSaleSortType[ListingSaleSortType["Contact5LocationNameASC"] = 613] = "Contact5LocationNameASC";
    ListingSaleSortType[ListingSaleSortType["Contact5LocationNameDESC"] = 614] = "Contact5LocationNameDESC";
})(ListingSaleSortType || (ListingSaleSortType = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.ContactRole */
export var ContactRole;
(function (ContactRole) {
    ContactRole[ContactRole["None"] = 0] = "None";
    ContactRole[ContactRole["Developer"] = 1] = "Developer";
    ContactRole[ContactRole["Architect"] = 2] = "Architect";
    ContactRole[ContactRole["RecordedOwner"] = 3] = "RecordedOwner";
    ContactRole[ContactRole["PropertyManager"] = 4] = "PropertyManager";
    ContactRole[ContactRole["PrimaryLeasingCompany"] = 6] = "PrimaryLeasingCompany";
    ContactRole[ContactRole["TrueOwner"] = 7] = "TrueOwner";
    ContactRole[ContactRole["SignAgent"] = 8] = "SignAgent";
    ContactRole[ContactRole["AssetManager"] = 9] = "AssetManager";
    ContactRole[ContactRole["BuyerBroker"] = 10] = "BuyerBroker";
    ContactRole[ContactRole["ListingBroker"] = 11] = "ListingBroker";
    ContactRole[ContactRole["TenantRep"] = 15] = "TenantRep";
    ContactRole[ContactRole["LeasingCompany"] = 20] = "LeasingCompany";
    ContactRole[ContactRole["SubletContact"] = 1000] = "SubletContact";
    ContactRole[ContactRole["PreviousTrueOwner"] = 1001] = "PreviousTrueOwner";
    ContactRole[ContactRole["PreviousRecordedOwner"] = 1002] = "PreviousRecordedOwner";
})(ContactRole || (ContactRole = {}));
import { OwnerSuperType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.OwnerSuperType */
export { OwnerSuperType };
/** CoStar.Api.SuiteSearchAdapter.ViewModels.Tags */
export var Tags;
(function (Tags) {
    Tags[Tags["None"] = 0] = "None";
    Tags[Tags["National"] = 1] = "National";
    Tags[Tags["Office"] = 2] = "Office";
    Tags[Tags["Industrial"] = 4] = "Industrial";
    Tags[Tags["Retail"] = 8] = "Retail";
    Tags[Tags["People"] = 16] = "People";
    Tags[Tags["Investment"] = 32] = "Investment";
    Tags[Tags["Analytics"] = 64] = "Analytics";
    Tags[Tags["Development"] = 128] = "Development";
    Tags[Tags["Finance"] = 256] = "Finance";
    Tags[Tags["Events"] = 512] = "Events";
    Tags[Tags["Multifamily"] = 1024] = "Multifamily";
    Tags[Tags["Hospitality"] = 2048] = "Hospitality";
    Tags[Tags["Company"] = 4096] = "Company";
    Tags[Tags["Healthcare"] = 8192] = "Healthcare";
    Tags[Tags["Legal"] = 16384] = "Legal";
    Tags[Tags["Land"] = 32768] = "Land";
    Tags[Tags["Lease"] = 65536] = "Lease";
    Tags[Tags["Sale"] = 131072] = "Sale";
    Tags[Tags["MixedUse"] = 262144] = "MixedUse";
    Tags[Tags["SpecialPurpose"] = 524288] = "SpecialPurpose";
    Tags[Tags["PublicSector"] = 1048576] = "PublicSector";
    Tags[Tags["CompaniesPeople"] = 2097152] = "CompaniesPeople";
    Tags[Tags["CoStarGreenReport"] = 4194304] = "CoStarGreenReport";
    Tags[Tags["Know"] = 8388608] = "Know";
    Tags[Tags["See"] = 16777216] = "See";
    Tags[Tags["Learn"] = 33554432] = "Learn";
})(Tags || (Tags = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.DetailLevel */
export var DetailLevel;
(function (DetailLevel) {
    DetailLevel[DetailLevel["None"] = 0] = "None";
    DetailLevel[DetailLevel["Summary"] = 1] = "Summary";
    DetailLevel[DetailLevel["Body"] = 2] = "Body";
    DetailLevel[DetailLevel["Metadata"] = 4] = "Metadata";
    DetailLevel[DetailLevel["TopAttachment"] = 8] = "TopAttachment";
    DetailLevel[DetailLevel["AllAttachments"] = 16] = "AllAttachments";
})(DetailLevel || (DetailLevel = {}));
import { Availability } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.ViewModels.Availability */
export { Availability };
/** CoStar.Api.SuiteSearchAdapter.ViewModels.CompanyAssociationType */
export var CompanyAssociationType;
(function (CompanyAssociationType) {
    CompanyAssociationType[CompanyAssociationType["None"] = 0] = "None";
    CompanyAssociationType[CompanyAssociationType["TrueBuyer"] = 1] = "TrueBuyer";
    CompanyAssociationType[CompanyAssociationType["TrueSeller"] = 2] = "TrueSeller";
    CompanyAssociationType[CompanyAssociationType["BuyerBroker"] = 3] = "BuyerBroker";
    CompanyAssociationType[CompanyAssociationType["ListingBroker"] = 4] = "ListingBroker";
    CompanyAssociationType[CompanyAssociationType["Lender"] = 5] = "Lender";
})(CompanyAssociationType || (CompanyAssociationType = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.SaleCompPinOptions */
export var SaleCompPinOptions;
(function (SaleCompPinOptions) {
    SaleCompPinOptions[SaleCompPinOptions["None"] = 0] = "None";
    SaleCompPinOptions[SaleCompPinOptions["ForSale"] = 1] = "ForSale";
})(SaleCompPinOptions || (SaleCompPinOptions = {}));
/** CoStar.Api.SuiteSearchAdapter.ViewModels.SpaceUseBitmap */
export var SpaceUseBitmap;
(function (SpaceUseBitmap) {
    SpaceUseBitmap[SpaceUseBitmap["Office"] = 1] = "Office";
    SpaceUseBitmap[SpaceUseBitmap["OfficeOrMedical"] = 2] = "OfficeOrMedical";
    SpaceUseBitmap[SpaceUseBitmap["OfficeOrRetail"] = 4] = "OfficeOrRetail";
    SpaceUseBitmap[SpaceUseBitmap["Medical"] = 8] = "Medical";
    SpaceUseBitmap[SpaceUseBitmap["Retail"] = 16] = "Retail";
    SpaceUseBitmap[SpaceUseBitmap["Flex"] = 32] = "Flex";
    SpaceUseBitmap[SpaceUseBitmap["Industrial"] = 64] = "Industrial";
    SpaceUseBitmap[SpaceUseBitmap["NULL_VALUE"] = 128] = "NULL_VALUE";
})(SpaceUseBitmap || (SpaceUseBitmap = {}));
